export default __webpack_public_path__ + "static/media/gpb.7ca1ebbd.png";